import { createClient } from "@sanity/client";
import type { SanityClient } from "@sanity/client";
import { config } from "./config";

let token = process.env.SANITY_API_TOKEN;

if (process.env.NEXT_PUBLIC_SANITY_API_TOKEN) {
  if (process.env.NODE_ENV === "development") {
    token = process.env.NEXT_PUBLIC_SANITY_API_TOKEN;
  } else {
    throw Error(
      `Should never supply NEXT_PUBLIC_SANITY_API_TOKEN outside of development. Current environment: ${process.env.NODE_ENV}`,
    );
  }
}

export function getClient(preview?: boolean): SanityClient {
  return createClient({
    dataset: "staging", // for now we are using staging, TODO: figure out needs for envs for sanity across projs
    projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || "",
    apiVersion: "2022-03-02",
    useCdn: !preview,
    perspective: preview ? "previewDrafts" : "published",
    token: token,
  });
}
